import React from 'react'
// import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import Radio from '@material-ui/core/Radio'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    minWidth: 140,
    minHeight: 42
  }
})

export default withStyles(styles)(
  class LeftHiboutikInfosComponent extends React.Component {
    render() {
      return (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          alignContent="space-between"
          spacing={24}>
          <Grid item xs={11} sm={10} md={10}>
            <img
              alt="hiboutik-logo"
              style={{ width: 'calc(100%)' }}
              src="https://www.hiboutik.com/images/logo_hiboutik_bleu.png?v=2"
            />
          </Grid>
          <Grid item xs={10} sm={9} md={9}>
            <Divider light />
          </Grid>
          <Grid
            item
            xs={11}
            sm={10}
            md={9}
            container
            justify="center"
            alignItems="center">
            <Grid item xs={2}>
              <Radio checked value="1" name="radio-button-1" aria-label="1" />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="subheading" align="left">
                Gérer et exporter vos documents comptables{' '}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            xs={11}
            sm={10}
            md={9}
            container
            justify="center"
            alignItems="center">
            <Grid item xs={2}>
              <Radio checked value="1" name="radio-button-2" aria-label="2" />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="subheading" align="left">
                Gestion de caisse (retraits, dépôts...)
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            xs={11}
            sm={10}
            md={9}
            container
            justify="center"
            alignItems="center">
            <Grid item xs={2}>
              <Radio checked value="1" name="radio-button-2" aria-label="2" />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="subheading" align="left">
                Personnalisation des tickets et des factures
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/HiboutikAccountCreation/LeftHiboutikInfosComponent.js